import React, { useEffect, useState } from 'react';
import Button from '../shared/Button';
import Icon from '../shared/Icon';
import './SplashNavbar.css';

export default function SplashNavbar({ visible, onJoinWaitlist, onBetaAccess, onDevAccess = () => {} }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isPresent, setIsPresent] = useState(visible);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsPresent(true);
      setIsLeaving(false);
      return;
    }

    if (isPresent) {
      setMenuOpen(false);
      setIsLeaving(true);
    }
  }, [visible, isPresent]);

  function handleAction(action) {
    setMenuOpen(false);
    action();
  }

  function handleAnimationEnd(event) {
    if (event.animationName === 'springDown' && isLeaving) {
      setIsLeaving(false);
      setIsPresent(false);
    }
  }

  if (!isPresent) return null;

  return (
    <header
      className={`splash-navbar${visible ? ' splash-navbar--visible' : ''}${isLeaving ? ' splash-navbar--leaving' : ''}`}
      aria-hidden={isLeaving}
      onAnimationEnd={handleAnimationEnd}
      onKeyDown={(event) => event.key === 'Escape' && setMenuOpen(false)}
    >
      <div className="splash-navbar__inner">
        <a className="splash-navbar__brand" href="#promo-sections" aria-label="FITNDEX learn more">
          <span className="splash-navbar__brand-mark" aria-hidden="true">F</span>
          <span className="splash-navbar__brand-copy">
            <strong>FITNDEX</strong>
            <small>Workout management platform</small>
          </span>
        </a>

        <nav className="splash-navbar__desktop-actions" aria-label="Public access">
          <Button variant="text" size="sm" onClick={() => onJoinWaitlist()}>
            Join the Waitlist
          </Button>
          <Button variant="primary" size="sm" onClick={() => onBetaAccess()}>
            Beta Tester
          </Button>
          <button
            type="button"
            className="splash-navbar__dev-toggle"
            aria-label="Developer options"
            title="Developer options"
            onClick={() => onDevAccess()}
          >
            <Icon name="gear" size={18} className="splash-navbar__dev-icon" />
          </button>
        </nav>

        <button
          className={`splash-navbar__menu-toggle${menuOpen ? ' splash-navbar__menu-toggle--open' : ''}`}
          type="button"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-controls="splash-navbar-menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path className="splash-navbar__menu-line splash-navbar__menu-line--top" d="M4 6.5H20" />
            <path className="splash-navbar__menu-line splash-navbar__menu-line--middle" d="M4 12H20" />
            <path className="splash-navbar__menu-line splash-navbar__menu-line--bottom" d="M4 17.5H20" />
          </svg>
        </button>
      </div>

      <nav
        className={`splash-navbar__mobile-menu${menuOpen ? ' splash-navbar__mobile-menu--open' : ''}`}
        id="splash-navbar-menu"
        aria-label="Mobile public access"
        aria-hidden={!menuOpen}
      >
        <Button variant="ghost" size="md" tabIndex={menuOpen ? 0 : -1} onClick={() => handleAction(onJoinWaitlist)}>
          Join the Waitlist
        </Button>
        <Button variant="primary" size="md" tabIndex={menuOpen ? 0 : -1} onClick={() => handleAction(onBetaAccess)}>
          Beta Tester
        </Button>
        <button
          type="button"
          className="splash-navbar__dev-toggle splash-navbar__dev-toggle--mobile"
          tabIndex={menuOpen ? 0 : -1}
          aria-label="Developer options"
          title="Developer options"
          onClick={() => handleAction(onDevAccess)}
        >
          <Icon name="gear" size={18} className="splash-navbar__dev-icon" />
        </button>
      </nav>
    </header>
  );
}